module.exports = __webpack_public_path__ + "static/media/3.ea8eb97b.jpg";